import { Injectable } from '@angular/core';
import { Aggregator } from '@liberty-financial/agp-shared';

import { aggregator } from '@env/aggregator/aggregator';
import { environment } from '@env/environment';
import { FeatureFlag } from '@env/environment.interface';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  isEnabled(featureFlag: FeatureFlag): boolean {
    return !!environment.features[featureFlag];
  }

  isLnsPanelLendersEnabled(): boolean {
    return aggregator.name === Aggregator.LNS && this.isEnabled(FeatureFlag.LnsPanelLenders);
  }
}
